/* eslint-disable object-shorthand */
import React from "react";
import { createDfpAdComponent } from "@quintype/components";
import get from "lodash/get";

const ViewPortSizeMappingBanner970x90and728x90 = [
  { viewport: [970, 0], sizes: [[970, 90]] },
  { viewport: [728, 0], sizes: [[728, 90]] },
];

const ViewPortSizeMappingBanner300x600 = [
  { viewport: [300, 0], sizes: [[300, 600]] },
  { viewport: [160, 0], sizes: [[160, 600]] },
  { viewport: [120, 0], sizes: [[120, 600]] },
];

const ViewPortSizeMappingBanner300x250 = [
  { viewport: [300, 0], sizes: [[300, 250]] },
  { viewport: [336, 0], sizes: [[336, 280]] },
  { viewport: [250, 0], sizes: [[250, 250]] },
  { viewport: [200, 0], sizes: [[200, 200]] },
];

const getStandard300x250Ad = (id) => ({
  adUnit: id,
  sizes: [
    [300, 250],
    [336, 280],
    [250, 250],
    [200, 200],
  ],
  viewPortSizeMapping: ViewPortSizeMappingBanner300x250,
});

const getStandard728x90Ad = (id) => ({
  adUnit: id,
  sizes: [[728, 90]],
});

const get970x90ResponsiveAd = (id) => ({
  adUnit: id,
  sizes: [
    [728, 90],
    [970, 90],
  ],
  viewPortSizeMapping: ViewPortSizeMappingBanner970x90and728x90,
});

const get320x50stickyAd = (id) => ({
  adUnit: id,
  sizes: [[320, 50]],
});

const get300x600Ad = (id) => ({
  adUnit: id,
  sizes: [
    [120, 600],
    [160, 600],
    [300, 600],
  ],
  viewPortSizeMapping: ViewPortSizeMappingBanner300x600,
});

const getHomeTopMobileAd = (id) => ({
  adUnit: id,
  sizes: [[320, 100]],
});

const getOutOfPageAd = (id) => ({
  adUnit: id,
  sizes: [[1, 1]],
});

const TQ_CONFIG = {
  tq_homeTopAd: get970x90ResponsiveAd("TQ21_HP_Sec_ATF_Top_LB_Desk_970x90"),
  tq_homeAndSecTopMobile: getHomeTopMobileAd("TQ21_HP_Sec_ATF_Top_LB_Mob_320x100"),
  tq_homePrem1: getStandard300x250Ad("TQ21_HP_ATF_Prem_300x250"),
  tq_homeATFMid: getStandard300x250Ad("TQ21_HP_ATF_Mid_300x250"),
  tq_homeBTF: getStandard300x250Ad("TQ21_HP_BTF_300x250"),
  tq_home300x600: get300x600Ad("TQ21_HP_ATF_300x600"),
  tq_homeAndsecSticky: get320x50stickyAd("TQ21_HP&Sec_Sticky_320x50"),
  tq_secTopAd: get970x90ResponsiveAd("TQ21_HP_Sec_ATF_Top_LB_Desk_970x90"),
  tq_secPrem1: getStandard300x250Ad("TQ21_Sec_ATF_Prem_300x250"),
  tq_secPremMid: getStandard300x250Ad("TQ21_Sec_ATF_Mid_300x250"),
  tq_secBTF: getStandard300x250Ad("TQ21_Sec_BTF_300x250"),
  tq_storyTopAd: get970x90ResponsiveAd("TQ21_ROS_ATF_Top_LB_Desk_970x90"),
  tq_storyContentATFDesktop: getStandard728x90Ad("TQ21_ROS_ATF_Mid_728x90"),
  tq_storyContentBTFDesktop: getStandard728x90Ad("TQ21_ROS_BTF_Low_728x90"),
  tq_storyPrem1: getStandard300x250Ad("TQ21_ROS_ATF_Prem_300x250"),
  tq_storyATFMid: getStandard300x250Ad("TQ21_ROS_ATF_Mid_300x250"),
  tq_storyBTF: getStandard300x250Ad("TQ21_ROS_BTF_300x250"),
  tq_storyBottomSticky: get320x50stickyAd("TQ21_ROS_Sticky_320x50"),
  tq_outOfPage: getOutOfPageAd("TQ21_Out_of_page_1x1_A"),
  tq_outOfPageB: getOutOfPageAd("TQ21_Out_of_page_1x1_B"),
};

const HQ_CONFIG = {
  hq_homeTopAd: get970x90ResponsiveAd("HQ21_HP_Sec_ATF_Top_LB_Desk_970x90"),
  hq_homeAndSecTopMobile: getHomeTopMobileAd("HQ21_HP_Sec_ATF_Top_LB_Mob_320x100"),
  hq_homePrem1: getStandard300x250Ad("HQ21_HP_ATF_Prem_300x250"),
  hq_homeATFMid: getStandard300x250Ad("HQ21_HP_ATF_Mid_300x250"),
  hq_homeBTF: getStandard300x250Ad("HQ21_HP_BTF_300x250"),
  hq_home300x600: get300x600Ad("HQ21_HP_ATF_300x600"),
  hq_homeAndsecSticky: get320x50stickyAd("HQ21_HP&Sec_Sticky_320x50"),
  hq_secTopAd: get970x90ResponsiveAd("HQ21_HP_Sec_ATF_Top_LB_Desk_970x90"),
  hq_secPrem1: getStandard300x250Ad("HQ21_Sec_ATF_Prem_300x250"),
  hq_secPremMid: getStandard300x250Ad("HQ21_Sec_ATF_Mid_300x250"),
  hq_secBTF: getStandard300x250Ad("HQ21_Sec_BTF_300x250"),
  hq_storyTopAd: get970x90ResponsiveAd("HQ21_ROS_ATF_Top_LB_Desk_970x90"),
  hq_storyContentATFDesktop: getStandard728x90Ad("HQ21_ROS_ATF_Mid_728x90"),
  hq_storyContentBTFDesktop: getStandard728x90Ad("HQ21_ROS_BTF_Low_728x90"),
  hq_storyPrem1: getStandard300x250Ad("HQ21_ROS_ATF_Prem_300x250"),
  hq_storyATFMid: getStandard300x250Ad("HQ21_ROS_ATF_Mid_300x250"),
  hq_storyBTF: getStandard300x250Ad("HQ21_ROS_BTF_300x250"),
  hq_storyBottomSticky: get320x50stickyAd("HQ21_ROS_Sticky_320x50"),
  hq_outOfPage: getOutOfPageAd("HQ21_Out_of_page_1x1"),
};

const FIT_CONFIG = {
  fit_homeTopAd: get970x90ResponsiveAd("FIT21_HP_Sec_ATF_Top_LB_Desk_970x90"),
  fit_homeAndSecTopMobile: getHomeTopMobileAd("FIT21_HP_Sec_ATF_Top_LB_Mob_320x100"),
  fit_homePrem1: getStandard300x250Ad("FIT21_HP_ATF_Prem_300x250"),
  fit_homeATFMid: getStandard300x250Ad("FIT21_HP_ATF_Mid_300x250"),
  fit_homeBTF: getStandard300x250Ad("FIT21_HP_BTF_300x250"),
  fit_home300x600: get300x600Ad("FIT21_HP_ATF_300x600"),
  fit_homeAndsecSticky: get320x50stickyAd("FIT21_HP&Sec_Sticky_320x50"),
  fit_secTopAd: get970x90ResponsiveAd("FIT21_HP_Sec_ATF_Top_LB_Desk_970x90"),
  fit_secPrem1: getStandard300x250Ad("FIT21_Sec_ATF_Prem_300x250"),
  fit_secPremMid: getStandard300x250Ad("FIT21_Sec_ATF_Mid_300x250"),
  fit_secBTF: getStandard300x250Ad("FIT21_Sec_BTF_300x250"),
  fit_storyTopAd: get970x90ResponsiveAd("FIT21_ROS_ATF_Top_LB_Desk_970x90"),
  fit_storyContentATFDesktop: getStandard728x90Ad("FIT21_ROS_ATF_Mid_728x90"),
  fit_storyContentBTFDesktop: getStandard728x90Ad("FIT21_ROS_BTF_Low_728x90"),
  fit_storyPrem1: getStandard300x250Ad("FIT21_ROS_ATF_Prem_300x250"),
  fit_storyATFMid: getStandard300x250Ad("FIT21_ROS_ATF_Mid_300x250"),
  fit_storyBTF: getStandard300x250Ad("FIT21_ROS_BTF_300x250"),
  fit_storyBottomSticky: get320x50stickyAd("FIT21_ROS_Sticky_320x50"),
  fit_outOfPage: getOutOfPageAd("FIT21_Out_of_page_1x1"),
};

const CONFIG = {
  ...TQ_CONFIG,
  ...HQ_CONFIG,
  ...FIT_CONFIG,
};

const DfpAdContent = createDfpAdComponent({
  defaultNetworkID: "22203938680",
  config: CONFIG,
  targeting: function (state, props) {
    const params = {
      environment: get(state, ["qt", "config", ["publisher-attributes"], "env"]),
      pageType: get(state, ["qt", "pageType"]),
      publisherName: get(state, ["qt", "config", "publisher-name"]),
      publisherId: get(state, ["qt", "config", "publisher-id"]) || 1,
    };

    if (get(state, ["qt", "pageType"]) === "section-page") {
      params.section = get(state, ["qt", "data", "collection", "slug"], "");
      params.sectionName = get(state, ["qt", "data", "collection", "slug"], "");
    }

    if (get(state, ["qt", "pageType"]) === "story-page") {
      params.Contextual_Article = get(props, ["story", "seo", "meta-keywords"], []);
      params.sectionName = get(props, ["story", "sections", "0", "name"], "");
    }

    if (
      get(state, ["qt", "pageType"]) === "story-page" &&
      get(state, ["qt", "data", "story", "metadata", "sponsored-by"])
    ) {
      params.sponsor = get(state, ["qt", "data", "story", "metadata", "sponsored-by"]);
      return params.sponsor;
    }

    return params;
  },
});

const DfpAd = (props) => {
  return (
    <div>
      <DfpAdContent {...props} />
    </div>
  );
};

export default DfpAd;
